// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Image from '@tcp/core/src/components/common/atoms/Image';
import Row from '@tcp/core/src/components/common/atoms/Row';
import blue from '../../../../../styles/themes/colors/blue';
import colors from '../../../../../styles/themes/TCP/colors';

export const SearchByKeywordsContainer = styled(Row)`
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    padding: ${(props) => (props.didyoumeanflag ? '0' : ' 8px 0 58px')};
    display: ${(props) => (props.didyoumeanflag ? 'none' : '')};
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    padding: ${(props) => (props.didyoumeanflag ? '0' : ' 8px 0 64px')};
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    padding: ${(props) => (props.didyoumeanflag ? '0' : ' 8px 0 81px')};
  }
`;

export const EmptySearchedLabel = styled.span`
  font-weight: ${(props) => props.theme.typography.fontWeights.extrabold};

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    display: block;
  }
`;
export const EmptySearchResultTitle = styled(Row)`
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XS} 0 0px;
  }

  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    padding: 0 0 10px;
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XXS} 0 10px;
  }
`;

export const EmptySearchResultSuggestion = styled(Row)`
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    padding: 12px 0 0;
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    padding: 14px 0;
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    padding: 14px 0 0;
  }
`;

export const SuggestionLabel = styled(Anchor)`
  font-weight: ${(props) =>
    props.didyoumeanflag ? '700' : props.theme.typography.fontWeights.extrabold};
  color: ${(props) =>
    props.didyoumeanflag
      ? `${colors.BUTTON.BLUE.LEFT_FILTERS_BTN}`
      : props.theme.colorPalette.blue[800]};
  text-decoration: ${(props) => (props.didyoumeanflag ? 'underline' : '')};
`;

export const EmptySearchInputBoxContainerWrapper = styled(Row)`
  margin: 0 auto;
  width: 100%;
  justify-content: center;
  padding-top: 50px;
  ${(props) =>
    props.didyoumeanflag
      ? 'padding-bottom: 60px;.empty-search-inputBox-container{ width: 750px;} .empty-search-input-withRecent {width: 100%;border-radius: 20px;height: 46px;} .empty-search-input {width: 750px;}'
      : ''}

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    padding-top: 28px;
    ${(props) =>
      props.didyoumeanflag
        ? 'align-items: flex-start;padding-bottom: 60px;.empty-search-inputBox-container{ width: 344px;} .empty-search-input-withRecent {width: 354px;border-radius: 20px;height: 42px;} .empty-search-input {width: 354px;}'
        : ''}
  }

  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    padding-top: 52px;
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    padding-top: 68px;
  }
`;

export const EmptySearchInputBoxCol = styled(Col)`
  position: relative;
  width: initial;
`;

export const SearchTipsMessageContainerWrapper = styled(Row)`
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    padding-top: 41px;
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    padding-top: 84px;
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    padding-top: 72px;
  }
`;

export const EmptySearchTipsTitle = styled(BodyCopy)`
  margin-bottom: 8px;

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    margin-bottom: 6px;
  }
`;

export const EmptySearchTipsItems = styled(BodyCopy)`
  color: ${(props) => props.theme.colorPalette.gray[1000]};
  font-weight: ${(props) => props.theme.typography.fontWeights.regular};
`;

export const EmptySearchInputBoxContainer = styled(BodyCopy)`
  position: relative;
  width: 240px;
  height: 40px;
`;

export const MatchBox = styled.div`
  width: 100%;
  display: table-cell;
  border-top: 0px;
  box-sizing: border-box;
  z-index: ${(props) => props.theme.zindex.zLoader};
  position: absolute;
  background-color: ${(props) => props.theme.colors.WHITE};
  overflow-y: auto;
  margin: 40px 10px 0 0;
`;

export const MatchLinkBox = styled.div`
  & .matchLinkBoxHead {
    height: 52px;
    background-color: ${(props) => props.theme.colors.ACCORDION.ACTIVE_HEADER};
    line-height: 52px;
    padding: 0px ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }
`;

export const EmptySearchImage = styled(Image)`
  position: absolute;
  float: none;
  top: calc(0% - -12px);
  width: 20px;
  height: 20px;
  right: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
`;

export const EmptySearchInput = styled.input`
  position: absolute;
  width: 240px;
  height: 40px;
  padding-left: 20px;
  padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
  border-radius: 20px;
  background-color: ${(props) => props.theme.colorPalette.gray[300]};
  border: 1px solid ${(props) => props.theme.colorPalette.gray[300]};
  box-sizing: border-box;
  outline: none;
  ${(props) =>
    props.className === 'empty-search-input-withRecent' &&
    `
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
      `}
`;

export const EmptySearchLinkName = styled(BodyCopy)`
  color: ${(props) => props.theme.colors.ACCORDION.TEXT};
  padding: 5px 14px;
`;

export const SuggestionBox = styled.div`
  width: 100%;
  display: block;
  border-top: 0;
  box-sizing: border-box;
  z-index: ${(props) => props.theme.zindex.zGoogleAutosuggest};
  position: relative;
  background-color: ${(props) => props.theme.colors.WHITE};
  overflow-y: auto;
`;

export const SuggestionLabelTextWrapper = styled.div`
  width: 100%;
`;

export const BoxHead = styled(BodyCopy)`
  font-size: 13px;
  font-weight: 600;
`;

export const SlpRelatedNoResponseSearch = styled.div`
  display: ${(props) =>
    props.isSlpPersistEnabled && props.isDidYouMeanEnabled ? 'block' : 'none'};
  .slp-persist-related-search {
    color: ${(props) => props.theme.colors.TEXT.BLUE};
    padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
    }
  }
  .related-search-wrapper {
    display: flex;
    margin: 10px 0px 10px 0px;
  }
  .related-searches {
    display: flex;
    flex-wrap: wrap;
  }
  .related-text {
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
    color: ${(props) => props.theme.colors.PRIMARY.DARK};
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
    }
  }
`;

export const DidYouMeanContainer = styled(BodyCopy)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 64px;
  .no-result-label {
    font-weight: bold;
    color: ${blue[500]};
    display: inline-block;
    padding-bottom: 20px;
  }
  .instead-search-label {
    font-size: 18px;
    color: ${colors.BLACK};
    font-style: italic;
  }
  .tips-null-search {
    padding-top: 24px;
    text-align: left;
    color: ${colors.BLACK};
  }
  .better-results {
    font-size: 18px;
  }
  .didyoumean-list {
    list-style-type: disc !important;
    margin-left: 20px;
  }
  .no-result-text {
    color: ${blue[500]};
  }
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    margin-top: 23px;
    align-items: flex-start;
    .no-result-label {
      font-size: 22px;
      margin-left: 13px;
    }
    .tips-null-search {
      margin-left: 13px;
    }
    .instead-search-label {
      margin-left: 13px;
    }
    .related-search-wrapper {
      margin-left: ${(props) => (props.isDidYouMeanEnabled ? '13px' : '')};
    }
  }
`;
